import {
  addTableArea,
  getBranchMap,
  addTable,
  updateTable,
  deleteArea,
  reorderTables,
} from "@/api/BranchSiteMap";
import draggable from "vuedraggable";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  components: {
    draggable,
    VuePerfectScrollbar,
  },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedButton: null,
      selectedButtonName: null,
      showNewAreaInput: false,
      newAreaName: "",
      isMobile: null,
      selectedArea: null,
    };
  },
  watch: {
    areas: {
      deep: true,
      handler(areas) {
        const area = areas.find((item) => item.id === this.selectedArea.id);
        if (area) {
          this.selectedArea = { ...area };
        }
      },
    },
  },
  computed: {
    isTableMove() {
      return this.$store.getters["selfservice/getIsTableMove"];
    },
    isTableMerge() {
      return this.$store.getters["selfservice/getIsTableMerge"];
    },
    areas() {
      return this.$store.getters["selfservice/getAreas"];
    },
    isActiveTablesFilter() {
      return this.$store.getters["selfservice/getIsActiveTablesFilter"];
    },
    displayedButtons() {
      if (this.isActiveTablesFilter) {
        let active = [];
        if (this.areas) {
            this.areas.forEach(area => {
                if (area.buttons) {
                    area.buttons.forEach(btn => {
                        if (btn.value && btn.value.isOccupied) {
                            active.push(btn);
                        }
                    });
                }
            });
        }
        return active.sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { numeric: true, sensitivity: 'base' }));
      }
      return this.selectedArea ? this.selectedArea.buttons : [];
    },
    dragModel: {
      get() {
        return this.displayedButtons;
      },
      set(val) {
        if (!this.isActiveTablesFilter && this.selectedArea) {
          this.selectedArea.buttons = val;
        }
      }
    }
  },
  async created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    await this.fetchAreas();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    getSelectedAreaId() {
      return localStorage.getItem("selectedAreaId") || "";
    },
    setSelectedAreaId(areaId) {
      localStorage.setItem("selectedAreaId", areaId);
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768; // Adjust this value as needed
    },
    /**
     * BranchTables/area yanıtındaki table.value ile harita kartı (rezerve / dolu / tutar)
     * gösterimini hizalar. paymentGroups boş ama cartEntries dolu vb. durumlarda
     * yanlış "Rezerve" veya tutarın hiç görünmemesi engellenir.
     */
    deriveTableButtonDisplay(tableValue, formatter) {
      const tv = tableValue || {};
      const parseNum = (x) => {
        if (typeof x === "number") return x;
        if (typeof x === "string") return parseFloat(x.replace(",", ".")) || 0;
        return Number(x) || 0;
      };

      const paymentGroups = Array.isArray(tv.paymentGroups) ? tv.paymentGroups : [];
      const cartEntries = Array.isArray(tv.cartEntries) ? tv.cartEntries : [];
      const entries = Array.isArray(tv.entries) ? tv.entries : [];

      // v136: Süreli ürünler için canlı fiyat hesaplama (Masa haritasında güncel tutar görünsün diye)
      let liveTotalPrice = parseNum(tv.totalPrice);
      
      const now = new Date();
      cartEntries.forEach(cartEntry => {
        // v142: PaymentGroups fall-back (Desync önlemi)
        let eTimeInfo = cartEntry;
        if (!cartEntry.isTime) {
           const pEntry = paymentGroups.flatMap(p => p.entries || []).find(e => e.id === cartEntry.id);
           if (pEntry && pEntry.isTime) { eTimeInfo = pEntry; }
        }

        if (eTimeInfo.isTime && eTimeInfo.hourPrice) {
           let totalMs = 0;
           
           // 1. Koşma süresi (Safe)
           if (eTimeInfo.isRunning && eTimeInfo.lastStartTime) {
              const lastStart = new Date(eTimeInfo.lastStartTime);
              if (lastStart.getFullYear() >= 2010) {
                 const elapsed = now - lastStart;
                 if (elapsed > 0 && elapsed < 1000 * 60 * 60 * 1000) {
                    totalMs += elapsed;
                 }
              }
           }

           // 2. Birikmiş süre (Safe)
           const tHour = parseNum(eTimeInfo.totalHour);
           if (tHour > 0 && tHour < 1000) {
              totalMs += tHour * 60 * 60 * 1000;
           }

           if (totalMs > 0) {
              const totalMinutes = totalMs / (1000 * 60);
              const pricePerMinute = eTimeInfo.hourPrice / 60;
              const currentLivePrice = Math.max(0.1, Math.ceil(totalMinutes) * pricePerMinute);
              
              const entryPrice = parseNum(cartEntry.price);
              if (currentLivePrice > entryPrice) {
                 liveTotalPrice += (currentLivePrice - entryPrice);
              }
           }
        }
      });

      const totalPrice = liveTotalPrice;
      const totalPayedPrice = parseNum(tv.totalPayedPrice);
      const remaining = Math.max(0, totalPrice - totalPayedPrice);

      const hasOrderPayload =
        paymentGroups.length > 0 ||
        cartEntries.length > 0 ||
        entries.length > 0 ||
        remaining > 0.0001;

      const isFullTable = !!tv.isFullTable;
      const isReserved = isFullTable && !hasOrderPayload;
      const isOccupied = isFullTable || hasOrderPayload;
      const showRemainingPrice = !isReserved && hasOrderPayload;

      return {
        ...tv,
        isFullTable,
        isReserved,
        isOccupied,
        showRemainingPrice,
        isAdisyonPrinted: !!tv.isAdisyonPrinted,
        remainingPrice: remaining,
        totalPrice: totalPrice // Güncellenmiş tutarı nesneye geri yazalım
      };
    },
    isTablePrinted(button) {
      if (!button || !button.value) return false;
      
      // v148: Otomatik Gizleme Kontrolü
      // 1. Masa boşsa hiçbir zaman gösterme
      if (!button.value.isOccupied) return false;

      // 2. Backend'den gelen bayrağı kontrol et (Ana kaynak)
      if (button.value.isAdisyonPrinted) return true;
      
      // 3. Fallback: Local store kontrolü (Anlık tepkisellik için)
      const carts = this.$store.getters["selfservice/getCarts"];
      if (carts && carts.length > 0) {
        // [v148] Eşleşmeyi sepet ID'si, masa ID'si veya UUID üzerinden yapıyoruz.
        const cart = carts.find(c => c && (
          c.id == button.id || 
          c.tableId == button.id || 
          (button.value && (c.branchTableUId === button.value.branchTableUId || c.BranchTableUId === button.value.branchTableUId)) ||
          (button.value && c.sid === button.value.branchTableUId)
        ));
        
        return !!(cart && cart.isAdisyonPrinted);
      }
      return false;
    },
    toggleArea(areaId) {
      const area = this.areas.find((a) => a.id === areaId);
      this.selectedArea = { ...area };
      this.setSelectedAreaId(area.id);
    },
    async fetchAreas() {
      // try {
      const response = await getBranchMap();
      const allCarts = [];
      const areas = response.data.map((area) => {
        if (
          !this.selectedArea &&
          area.id.toString() === this.getSelectedAreaId()
        ) {
          this.selectedArea = { ...area };
          this.setSelectedAreaId(this.selectedArea.id);
        }

        // v131: Sort tables naturally (e.g., A-1, A-2, ..., A-10) before mapping
        const sortedTables = [...(area.tables || [])].sort((a, b) => 
          (a.name || "").localeCompare(b.name || "", undefined, { numeric: true, sensitivity: 'base' })
        );

        return {
          id: area.id,
          name: area.name,
          buttons: sortedTables.map((table) => {
            const tableValue = table.value;
            allCarts.push(tableValue);
            const formatter = new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY",
            });

            return {
              id: table.id,
              name: table.name,
              active: true,
              isMerged: tableValue.isMerged,
              mergedIds: tableValue.mergedIds,
              value: this.deriveTableButtonDisplay(tableValue, formatter),
            };
          }),
          showNewTableInput: this.showNewTableInput,
          newTableNumber: this.selectedArea
            ? this.selectedArea.newTableNumber
            : null,
          isOpen: false, // Add this line
        };
      });
      this.$store.dispatch("selfservice/setAreas", areas);
      this.$store.dispatch("selfservice/updateCartsById", allCarts);
      if (!this.selectedArea) {
        this.selectedArea = { ...areas[0] };
      }
      this.setSelectedAreaId(this.selectedArea.id);
      /* } catch (error) {
        if (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: error.response.data.Errors[0].Message,
          });
        }
        console.error("Error fetching areas:", error);
      } */
    },
    handleButtonClick(button) {
      if (
        this.isTableMove &&
        this.selectedButton &&
        this.selectedButton !== button.id
      ) {
        this.$emit("startMoveTable", this.selectedButton, button.id);
        return;
      } else if (
        this.isTableMerge &&
        this.selectedButton &&
        this.selectedButton !== button.id
      ) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: `Masa Birleştirme`,
          text: `${this.selectedButtonName} masasını ${button.name} masasına birleştirmek istediğinize emin misiniz?`,
          accept: () => {
            this.mergeTable(this.selectedButton, button.id);
          },
        });
      } else {
        this.toggleButton(button);
        if (this.editMode) {
          this.showUpdateTableInput(this.selectedArea.id);
        }
      }
    },
    toggleButton(button) {
      if (this.selectedButton === button.id) {
        const index = this.areas.findIndex((area) =>
          area.buttons.some((areaButton) => areaButton.id === this.selectedButton)
        );
        if (index > -1) {
          this.$store.dispatch("selfservice/updateArea", {
            index,
            value: { newTableNumber: "" },
          });
        }
        this.selectedButton = null;
        this.selectedButtonName = null;
        this.$emit("un-select-table");
      } else {
        this.selectedButton = button.id;
        this.selectedButtonName = button.name;
        const index = this.areas.findIndex((area) =>
          area.buttons.some((areaButton) => areaButton.id === this.selectedButton)
        );
        if (index > -1) {
          this.$store.dispatch("selfservice/updateArea", {
            index,
            value: { newTableNumber: button.name },
          });
        }
      }
      this.$emit("table-selected", this.selectedButton);
    },
    moveTable(fromTableId, toTableId) {
      // Implement the table moving logic here
      this.$emit("moveTable", fromTableId, toTableId);
      // Reset selection after moving
      this.selectedButton = null;
      this.selectedButtonName = null;
      this.$store.dispatch("selfservice/setIsTableMove", false);
    },
    mergeTable(fromTableId, toTableId, description) {
      this.$emit("mergeTableAction", fromTableId, toTableId, description);
      // Reset selection after merging
      this.selectedButton = null;
      this.selectedButtonName = null;
      this.$store.dispatch("selfservice/setIsTableMerge", false);
    },
    getButtonStyle(button) {
      const baseStyle = {
        padding: "0.1rem",
        width: "100%",
        height: "100%",
        "aspect-ratio": "1",
        borderRadius: "0.8rem !important",
        fontSize: "0.875rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "black",
        border: "2px solid rgba(106, 31, 19)",
        overflow: "hidden",
        "user-select": "none",
        "-webkit-user-select": "none",
        "-webkit-touch-callout": "none",
      };

      if (this.selectedButton === button.id) {
        return {
          ...baseStyle,
          backgroundColor: "#6366f1",
          color: "white",
          boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
          border: "2px solid #4f46e5",
          transform: "scale(1.05)",
          fontWeight: "600",
        };
      }

      if (button.value.isOccupied === true) {
        return {
          ...baseStyle,
          backgroundColor: !button.value.isReserved ? "#84d9b0" : "#fee47e", // Light green color
        };
      }

      if (button.active) {
        return {
          ...baseStyle,
          backgroundColor: "white",
        };
      } else {
        return {
          ...baseStyle,
          backgroundColor: "white",
        };
      }
    },
    formatLockedName(fullName) {
      if (!fullName) return "";
      const parts = fullName.trim().split(" ");
      if (parts.length === 1) return parts[0];
      const firstName = parts[0];
      const lastName = parts[parts.length - 1];
      return `${firstName} ${lastName.charAt(0)}...`;
    },
    async addNewArea() {
      if (this.newAreaName) {
        try {
          const response = await addTableArea({ name: this.newAreaName });
          const newAreaId = response.data;
          this.areas.push({
            id: newAreaId,
            name: this.newAreaName,
            buttons: [],
            showNewTableInput: false,
            newTableNumber: "",
            isOpen: false, // Add this line
          });
          this.newAreaName = "";
          this.showNewAreaInput = false;
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: error.response.data.Errors[0].Message,
          });
          console.error("Error adding new area:", error);
        }
      }
    },
    showNewTableInput(areaId) {
      const index = this.areas.findIndex((a) => a.id === areaId);
      if (index > -1) {
        this.selectedButton = null;
        this.selectedButtonName = null;
        this.$store.dispatch("selfservice/updateArea", {
          index,
          value: { showNewTableInput: true, newTableNumber: "" },
        });
      }
    },
    showUpdateTableInput(areaId) {
      const index = this.areas.findIndex((a) => a.id === areaId);
      if (index > -1) {
        this.$store.dispatch("selfservice/updateArea", {
          index,
          value: { showNewTableInput: true },
        });
      }
    },
    async addNewTable() {
      const area = this.selectedArea;
      if (area && area.newTableNumber) {
        try {
          if (this.selectedButton == null) {
            const response = await addTable({
              name: area.newTableNumber,
              tableCartAreaId: area.id,
            });
            const newTable = response.data;
            await this.fetchAreas();
            this.$emit("addCart", newTable);
          } else {
            await updateTable({
              name: area.newTableNumber,
              id: this.selectedButton,
            });
            await this.fetchAreas();
          }
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: error.response.data.Errors[0].Message,
          });
        }
      }
    },
    confirmDeleteArea(areaId, areaName) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Alanı Sil",
        text: `"${areaName}" isimli alanı silmek istediğinize emin misiniz?`,
        acceptText: "Evet, Sil",
        cancelText: "İptal",
        accept: () => this.deleteArea(areaId),
        cancel: () => { },
      });
    },
    async deleteArea(areaId) {
      try {
        await deleteArea(areaId);
        await this.fetchAreas();
      } catch (error) {
        console.error("Error deleting area:", error);
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: error.response.data.Errors[0].Message,
        });
      }
    },
    async onDragChange(areaId) {
      if (this.editMode) {
        if (this.selectedArea) {
          const newOrder = this.selectedArea.buttons.map((button, index) => ({
            id: button.id,
            newOrder: index + 1,
            name: button.name,
          }));

          try {
            await reorderTables(newOrder);
          } catch (error) {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error.response.data.Errors[0].Message,
            });
            console.error("Error updating table order:", error);
          }
        }
      }
    },
    getMergedTableName(button) {
      if (button.mergedIds && button.mergedIds.length > 0) {
        const mergedNames = button.mergedIds
          .map((id) => {
            const mergedButton = this.areas
              .flatMap((area) => area.buttons)
              .find((b) => b.id === id);
            return mergedButton ? mergedButton.name : "";
          })
          .filter((name) => name !== "");

        return `${button.name} - ${mergedNames.join("-")}`;
      }
      return button.name;
    },
    handleTouchStart(button) {
      if (this.isMobile && button.value.isOccupied) { // v121: Only long press for occupied tables
        this.longPressTimer = setTimeout(() => {
          this.handleLongPress(button);
        }, this.longPressDelay);
      }
    },
    handleTouchEnd() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },
    handleTouchMove() {
      // Clear timer if finger moves (scrolling)
      this.handleTouchEnd();
    },
    handleLongPress(button) {
      this.longPressTimer = null;
      if (window.navigator && window.navigator.vibrate) {
        window.navigator.vibrate(50); // Small feedback vibration
      }
      this.$emit("long-press-table", button.id);
    },
  },
};